<script>
export default {
    name: 'Marquee',
    functional: true,
    props: {
        duration: {
            type: Number,
            default: 15
        },
        repeat: {
            type: Number,
            default: 2,
            validator: function (val) {
                return val >= 2;
            }
        },
        paused: {
            type: Boolean,
            default: false
        },
        ready: {
            type: Boolean,
            default: true
        }
    },
    render (h, { $style, props: { duration, repeat, paused, ready }, children, data: { staticClass, key } }) {
        const item = h('div', {
            class: [
                ready ? $style.animate : $style.noanimate
            ],
            style: {
                animationDuration: `${duration}s`
            }
        }, children);
        return h('div', {
            key,
            class: [
                staticClass,
                $style.wrap
            ]
        }, [
            h('div', {
                class: [
                    paused
                        ? $style.paused
                        : undefined,
                    $style.content
                ]
            }, Array(repeat).fill(item))
        ]);
    }
};
</script>

<style module>
  .wrap {
    overflow: hidden;
    height: 100%;
  }
  .content {
    width: 100000px;
    height: 100%;
  }
  .content img {
    height: 100%;
  }
  .noanimate {
    height: 100%;
    animation: none !important;
  }
  .animate {
    height: 100%;
    animation-name: animation;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    float: left;
  }
  .paused .animate {
    animation-play-state: paused;
  }
  @keyframes animation {
    0% { transform:translateX(0); }
    100% { transform:translateX(-100%); }
  }
</style>
